import { color, textStyleBody, spacing } from '@uniquegood/realworld-studio-design';
import { css } from '@emotion/react';
import { AlignCenterFlex } from '@/styles';
import { BELT_BANNER_HEIGHT } from '@/constants/common';

export type SettingsMenuType = 'channel' | 'members' | 'donations' | 'plan';

interface SubSidebarProps {
  onSelectMenu: (menu: SettingsMenuType) => void;
  selectedMenu: SettingsMenuType;
}

const MENU_ITEMS = [
  { id: 'channel', label: '채널 설정' },
  { id: 'members', label: '구성원 관리' },
  { id: 'donations', label: '후원 및 판매' },
  { id: 'plan', label: '요금제 관리' }
] as const;

function SubSidebar({ onSelectMenu, selectedMenu }: SubSidebarProps) {
  return (
    <aside css={SubSidebarContainer} role="group">
      {MENU_ITEMS.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onSelectMenu(item.id)}
          css={[MenuButtonStyle, selectedMenu === item.id && MenuItemActive]}
          aria-pressed={selectedMenu === item.id}
        >
          <span css={MenuLabelStyle}>{item.label}</span>
        </button>
      ))}
    </aside>
  );
}

const SubSidebarContainer = css`
  position: sticky;
  top: ${BELT_BANNER_HEIGHT}px;
  display: flex;
  width: 144px;
  height: 100vh;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex-shrink: 0;
  background-color: ${color.surface_default_default};
  border-left: 1px solid #f5f5f5;
`;

const MenuButtonStyle = css`
  border: none;
  background: none;
  padding: 8px 12px;
  width: 112px;
  cursor: pointer;
  ${AlignCenterFlex}
  gap: ${spacing.common.small};
  ${textStyleBody}
  transition: color 0.2s ease;
  border-radius: ${spacing.borderRadius.medium};

  :focus-visible {
    box-shadow: 0 0 0 4px ${color.focused_default} inset;
    outline: none;
  }

  &:hover {
    background-color: ${color.surface_default_subdued};
    border-radius: ${spacing.borderRadius.medium};
  }
`;

const MenuItemActive = css`
  background-color: ${color.surface_default_subdued};
`;

const MenuLabelStyle = css`
  white-space: nowrap;
`;

export default SubSidebar;
